export const ROUTES = {
  LOGIN_PAGE: "/login",
  // TWO_FA: '/two-factor-authentication',

  MAIN_PAGE: "/",
  PLAYERS: "/players",
  USERS: "/users",
  PLANS: "/plans",
  SETTINGS: "/settings",
  TRANSACTIONS: "/transactions",
  POPUPS: "/popups",
  NOTIFICATIONS: "/notifications",
  CONFIGURATIONS: "/configurations",

  NOT_FOUND: "*",
  INTERNAL_SERVER: "/500",
  ACCESS_DENIED: "/403",
  RESTRICTED_USERNAMES: "/restricted-usernames",
};
